import React from "react";
import { observer, useLocalStore } from "mobx-react";
import { Grid } from "@mui/material";
import { EOCAsyncSelect } from "../input/EOCAsyncSelect";
import apiCall from "../../scripts/apiCall";
import { useMsal } from "@azure/msal-react";

export default observer(
  ({
    title,
    value,
    required,
    updatefunc,
    multi = false,
    isCreatable = false,
    viewonly = false,
    viewFrame = true,
    salesOrg,
    customer,
    customerId = false,
  }) => {
    const { instance, accounts } = useMsal();
    const getData = (input) =>
      new Promise((resolve) => {
        let fetchOptions = {
          method: "POST",
          credentials: "same-origin",
          body: JSON.stringify({
            proj: "Z_GW_ARCH_ORDER_SRV",
            funct: "MaterialSet",
            //parameters: `$format=json`,
            parameters:
              "$top=40&$format=json&$filter=" +
              (customerId
                ? `CustomerID eq '${input.toUpperCase()}*'`
                : `MaterialID eq '${input.toUpperCase()}*'`) +
              (salesOrg ? `and SalesOrg eq '${salesOrg}'` : "") +
              (customer ? `and SoldTo eq '${customer}'` : ""),
          }),
        };
        var sys = window.localStorage.getItem("QUOTEsys");
        let url = `SAPOData${sys}`;

        return apiCall(
          url,
          fetchOptions,
          (json) => {
            resolve(
              json.map((result) => ({
                Id: result.MaterialID,
                Name: result.MaterialDescription,
                cusId: result.CustomerID,
                cusName: result.CustomerDesc,
                value: customerId ? result.CustomerID : result.MaterialID,
                label: customerId
                  ? result.CustomerDesc + " (" + result.CustomerID + ")"
                  : result.MaterialDescription + " (" + result.MaterialID + ")",
              }))
            );
          },
          instance,
          accounts
        );
      });

    const lstore = useLocalStore(() => ({
      onChange(newVal, actionMeta) {
        if (newVal !== null) {
          if (multi) {
            if (isCreatable && actionMeta.action === "create-option")
              newVal.forEach((element) => {
                if (element.__isNew__) {
                  element.Name = element.label;
                  element.Id = "0";
                }
              });
            updatefunc(newVal);
          } else {
            if (newVal.__isNew__) {
              newVal.Name = newVal.label;
              newVal.Id = "0";
            }
            updatefunc(newVal);
          }
        } else {
          updatefunc(null);
        }
      },
    }));
    if (viewonly)
      return (
        <Grid container spacing={0} direction="column">
          {viewFrame && (
            <Grid item xs>
              <label>
                {title}
                {required && " *"}
              </label>
            </Grid>
          )}
          <Grid item xs>
            <p>{value.label}</p>
          </Grid>
        </Grid>
      );
    return (
      <Grid container spacing={0} direction="column">
        {viewFrame && (
          <Grid item xs>
            <label>
              {title}
              {required && " *"}
            </label>
          </Grid>
        )}
        <Grid item xs>
          <EOCAsyncSelect
            cy={title}
            isMulti={multi}
            loadOptions={getData}
            value={value}
            updateF={lstore.onChange}
            clearAble={isCreatable}
            isCreatable={isCreatable}
            defaultOptions
          />
        </Grid>
      </Grid>
    );
  }
);
